/*
 * @Author: zhuqiu
 * @Date: 2020-05-19 13:53:54
 * @LastEditTime: 2022-02-17 19:06:19
 * @LastEditors: Fu Zhuohang
 * @Description: In User Settings Edit
 * @FilePath: \yunshu6.0-3\modules\@cloudpivot\form\src\components\Modifier\conduct.ts
 */
import baseAttribute from "../../../../form/src/common/component-base-attribute";
import { ControlAttributeType } from "../../../../form/typings";
import { formatterValueToSetStatus } from "../../../../form/utils";
import i18n from "../../../i18n";
export default {
    groups: {
        base: {
            label: "基础信息",
            keys: ["name", "labelVisible", "visible", "style", "tips", "widgetType"],
        },
        controller: {
            label: "控制属性",
            keys: [],
        },
    },
    properties: {
        name: Object.assign({}, baseAttribute.name),
        dataItemName: Object.assign({}, baseAttribute.dataItemName),
        style: Object.assign({}, baseAttribute.style),
        widgetType: Object.assign({}, baseAttribute.widgetType, { value: i18n.t('dataitem.Modifier').toString() }),
        dataItemType: Object.assign({}, baseAttribute.dataItemType, { value: i18n.t('dataitem.StaffSelector').toString() }),
        mappings: {
            inputMethod: ControlAttributeType.Modal,
            inputComponent: () => import("../../../../form/src/common/components/user-selection-map2.vue"),
            options: {},
            formatter: formatterValueToSetStatus,
        },
    },
};
